import React, { useEffect, useState } from "react";
import styles from "./LoanDetailsMenu.module.scss";
import { ReactComponent as ChevronRight } from "assets/images/v2/chevron-right.svg";
import { ReactComponent as LoanIcon } from "assets/images/v2/sack-dollar.svg";
import LoanDetails from "../loan-details/LoanDetails";

interface LoanDetailsMenuProps {
  onLoad?: () => void;
}

const LoanDetailsMenu: React.FC<LoanDetailsMenuProps> = ({ onLoad }) => {
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  const handleLoanDetailsClick = () => {
    setShowLoanDetails(true);
  };

  return (
    <>
      {showLoanDetails ? (
        <LoanDetails onLoad={onLoad} />
      ) : (
        <div className={styles.content}>
          <h1 className={styles.title}>More</h1>
          <div className={styles.menuCard} onClick={handleLoanDetailsClick} onKeyDown={handleLoanDetailsClick}>
            <div className={styles.menuLeft}>
              <LoanIcon className={styles.icon} />
              <div className={styles.textWrapper}>
                <div className={styles.menuTitle}>Loan Details</div>
                <div className={styles.descriptionRow}>
                  <div className={styles.description}>Overview of loan details and payment information.</div>
                </div>
              </div>
            </div>
            <ChevronRight className={styles.chevron} />
          </div>
        </div>
      )}
    </>
  );
};

export default LoanDetailsMenu;
